/**
 * Verona Tempo — fix round 1: collection pages.
 *
 *  1. Colour and Size filters made by the theme (the manager's Search & Discovery app still only gives us
 *     "Availability" and "Price"). The real colours and sizes of the WHOLE collection are read once from
 *     /collections/<handle>?view=vtdata (templates/collection.vtdata.liquid), in the background, after the
 *     first paint, and kept for the visit. Choosing a colour or a size then re-draws the list from the whole
 *     collection — not only from the page she can see. The cards themselves are always the shop's own
 *     rendered cards (fetched with the section rendering API), so they look exactly the same.
 *     The address keeps the choice (?vtf.color=Black,Beige&vtf.size=38), so the view can be shared and the
 *     back button works.
 *     Setting: Theme settings > Verona Tempo > "(fix round) Colour and size filters" — Automatic / On / Off.
 *     "Automatic" uses the theme's filters only while Shopify gives the shop no colour or size filter of its
 *     own; the day the manager adds them in Search & Discovery, Shopify's filters take over by themselves.
 *
 *  2. Infinite scroll: the next page loads by itself when she comes near the end (about 600 px before it).
 *     The real "Load more" button stays for the keyboard and for browsers without IntersectionObserver, and
 *     the ordinary page links stay in the HTML for Google. After 10 pages loaded by themselves the button
 *     becomes "Show more" and she has to ask for the rest (so the page never grows for ever).
 *
 *  3. Sold-out products last across the WHOLE collection, not page by page: while the pages come in, the
 *     sold-out cards are held aside and put back at the very end, once the last page has arrived.
 *
 *  Fixes 2: a piece she asks for in a colour or a size we have SOLD OUT no longer disappears. The list now
 *     ends with a quiet line ("Sold out in this colour or size") and then those pieces, greyed out, with the
 *     shop's usual sold-out card (soft photo + "Sold out"). The counts — the numbers beside each colour and
 *     size and the "Show N products" line — still count only what she can actually buy.
 *
 *  Loaded (deferred) after assets/vt-collection.js on collection pages only (layout/theme.liquid).
 *  Styles: assets/vt-fix1.css. Texts: vt.tfilter.* and vt.infinite.* (English + Arabic).
 *  To go back: untick "(fix round) Infinite scroll" / "(fix round) Sold-out items last" or set the colour and
 *  size filters to "Off" in Theme settings > Verona Tempo. Nothing was removed.
 */
(function () {
  'use strict';
  if (window.vtFix1Coll) return;
  window.vtFix1Coll = true;

  var core = window.vtCore || {};
  var cfg = (window.vtConfig || {}).collection || {};
  var TF = cfg.tfilter || {};
  var S = TF.strings || {};
  var announce = core.announce || function () {};
  var onListingRefresh = core.onListingRefresh || function () {};
  var storageGet = core.storageGet || function () { return null; };
  var storageSet = core.storageSet || function () {};

  var MAX_AUTO_PAGES = 10;   // never load more than this many pages by itself
  var SENTINEL_MARGIN = '600px 0px';

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function tpl(s, vals) {
    return String(s || '').replace(/\[(\w+)\]/g, function (m, k) { return vals[k] != null ? vals[k] : m; });
  }
  // "Show 1 product" / "Show 12 products" — the shop's two wordings, picked here
  function nOf(n, many, one) { return tpl(n === 1 && one ? one : many, { count: n }); }
  function fc() { return document.querySelector('filter-container'); }
  function grid() { return document.querySelector('filter-container .collection-listing .product-grid'); }
  function row() { return document.querySelector('.pagination-row'); }
  function moreBtn() { return document.querySelector('[data-vt-load-more]'); }
  function nextUrl() { var b = moreBtn(); return (b && b.dataset.nextUrl) || ''; }
  function isSold(el) {
    return el.hasAttribute('data-vt-sold') || el.classList.contains('product-block--vt10-sold');
  }
  function cards(scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll('product-block'));
  }

  /* ================================================================== 3. sold-out last, whole collection ===
     Page 1 already has its own sold-out products at the end (the section does that in Liquid), but the
     in-stock products of page 2 would then come after them. So every sold-out card is taken out and held
     until the last page has arrived. */
  var soldBuf = [];
  var soldOn = false;

  // 7 Oct 2026 (ads team): pieces with only a few sizes left (data-vt-low) are held the same way and come back
  // after the well-stocked ones, before the sold-out ones
  var lowBuf = [];
  var partBuf = []; // 8 Oct 2026: 4+ sizes with some missing — between the full ones and the 1-3 size ones
  function isLow(el) { return el.hasAttribute('data-vt-low') && !isSold(el); }
  function isPart(el) { return el.hasAttribute('data-vt-part') && !isSold(el); }

  function soldFlush() {
    if (!soldBuf.length && !lowBuf.length && !partBuf.length) return;
    var g = grid();
    if (!g) return;
    partBuf.forEach(function (el) { g.appendChild(el); });
    partBuf = [];
    lowBuf.forEach(function (el) { g.appendChild(el); });
    lowBuf = [];
    soldBuf.forEach(function (el) { g.appendChild(el); });
    soldBuf = [];
    if (window.vtDrawCardLists) window.vtDrawCardLists();
    document.dispatchEvent(new CustomEvent('vt:soldout:flushed'));
  }

  function soldHarvest() {
    if (!soldOn) return;
    // while a colour / size filter is on, the theme draws the list itself (and never shows a sold-out product)
    if (document.body.classList.contains('vt-tf-on')) return;
    var g = grid();
    if (!g) return;
    // the last page's own few-sizes / sold-out cards are set aside too, then everything held comes back in order
    cards(g).forEach(function (el) {
      if (el.parentNode !== g) return;
      if (isSold(el)) { g.removeChild(el); soldBuf.push(el); }
      else if (isLow(el)) { g.removeChild(el); lowBuf.push(el); }
      else if (isPart(el)) { g.removeChild(el); partBuf.push(el); }
    });
    if (!nextUrl()) soldFlush();
  }

  function soldReset() {
    soldBuf = [];
    lowBuf = [];
    partBuf = [];
  }

  function initSoldLast() {
    if (!TF.soldLast) return;
    soldOn = true;
    soldHarvest();
    document.addEventListener('vt:products:appended', soldHarvest);
    onListingRefresh(function () { soldReset(); window.setTimeout(soldHarvest, 0); });
  }

  /* ========================================================================= 2. infinite scroll ============
     A small marker is put just before the pagination row; when it comes within about 600 px of the screen the
     next page is asked for. The button itself stays — without JavaScript, without IntersectionObserver and
     for anybody moving with the keyboard it is the only way on, and Google still follows the page links. */
  function initInfinite() {
    if (!TF.infinite) return;
    var r = row();
    if (!r) return;
    var wrap = r.querySelector('.vt-load-more');
    if (wrap) wrap.classList.add('vt-inf');
    if (!('IntersectionObserver' in window)) return;

    var bar = document.createElement('div');
    bar.className = 'vt-inf__progress';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<span></span>';
    var live = document.createElement('p');
    live.className = 'vt-inf__live visually-hidden';
    live.setAttribute('role', 'status');
    live.setAttribute('aria-live', 'polite');
    r.insertBefore(bar, r.firstChild);
    r.appendChild(live);

    var sentinel = document.createElement('div');
    sentinel.className = 'vt-inf__sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    r.parentNode.insertBefore(sentinel, r);

    var auto = 0;
    var busy = false;

    function manual() {
      var b = moreBtn();
      if (!b) return;
      b.classList.add('vt-inf__btn--manual');
      var label = b.querySelector('[data-vt-load-more-label]');
      if (label && S.showMore) label.textContent = S.showMore;
    }

    function pull() {
      var b = moreBtn();
      if (!b || busy) return;
      if (b.getAttribute('aria-busy') === 'true') return;
      if (document.body.classList.contains('vt-tf-on')) return; // the theme filters draw the list themselves
      if (auto >= MAX_AUTO_PAGES) { manual(); return; }
      auto += 1;
      busy = true;
      r.classList.add('vt-inf-loading');
      if (S.loadingMore) live.textContent = S.loadingMore;
      b.click();
    }

    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) pull();
    }, { rootMargin: SENTINEL_MARGIN });
    io.observe(sentinel);

    function done() {
      busy = false;
      r.classList.remove('vt-inf-loading');
      live.textContent = '';
      if (!nextUrl() && S.allShown) live.textContent = S.allShown;
      // still near the end (a short page): keep going
      window.setTimeout(function () {
        var box = sentinel.getBoundingClientRect();
        if (box.top < (window.innerHeight || 0) + 600) pull();
      }, 120);
    }
    document.addEventListener('vt:products:appended', done);
    // 8 Oct 2026: loading failed (connection dropped) — stop loading by itself; the button now says "tap to try again"
    document.addEventListener('vt:products:loadfail', function () {
      busy = false;
      auto = MAX_AUTO_PAGES;
      r.classList.remove('vt-inf-loading');
      live.textContent = '';
      var b = moreBtn();
      if (b) b.classList.add('vt-inf__btn--manual');
    });
    onListingRefresh(function () { auto = 0; busy = false; r.classList.remove('vt-inf-loading'); });
  }

  /* ======================================================================== 1. colour + size filters =======
     The whole collection's colours and sizes, with real counts, worked out from ?view=vtdata. */
  var data = null;        // { total, pages, items: [ { i, a, v: [[colour, size], …], x: […sold out], c: [[colour, base], …] } ] }
  var DATA_V = 3;         // fixes 2 bumped this (sold-out pairs); 30 Sep 2026: 3 = each colour's own photo ("p")
  var baseOf = {};        // "أسود" -> "black" — so the round swatch is filled in on the Arabic pages too
  var SWATCH_KEYS = TF.swatchKeys || [];
  var dataState = 'idle'; // idle | loading | ready | error
  var sel = { color: [], size: [] };
  var serverKids = null;  // the shop's own cards, kept aside while a theme filter is on
  var cardCache = {};     // product id -> the shop's own card for it
  var pagesFetched = {};
  var shown = 0;
  var matches = [];       // the pieces she can buy in the colour / size she asked for — these are counted
  var soldMatches = [];   // fixes 2: the pieces that match but are sold out in it — shown last, greyed, never counted
  var soldShown = 0;
  var tfOn = false;
  // 30 Sep 2026: every new filter choice starts a new "generation"; a list still loading for an older choice is
  // dropped, and one list is only ever drawn once at a time (two at once is what showed every shoe twice)
  var gen = 0;
  var drawing = null;

  function shopQuery() {
    // everything in the address except our own vtf.* choices
    var p = new URLSearchParams(window.location.search);
    var out = new URLSearchParams();
    p.forEach(function (v, k) { if (k.indexOf('vtf.') !== 0 && k !== 'page' && k !== 'section_id' && k !== 'view') out.append(k, v); });
    return out.toString();
  }
  function dataKey() { return 'vtf:' + window.location.pathname + '?' + shopQuery(); }

  function readUrl() {
    var p = new URLSearchParams(window.location.search);
    sel.color = (p.get('vtf.color') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    sel.size = (p.get('vtf.size') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  }
  function writeUrl(push) {
    var p = new URLSearchParams(window.location.search);
    if (sel.color.length) p.set('vtf.color', sel.color.join(',')); else p.delete('vtf.color');
    if (sel.size.length) p.set('vtf.size', sel.size.join(',')); else p.delete('vtf.size');
    var q = p.toString();
    var url = window.location.pathname + (q ? '?' + q : '') + window.location.hash;
    try { history[push ? 'pushState' : 'replaceState']({ vtf: 1 }, '', url); } catch (e) { /* older browser */ }
  }

  function fetchJson(page) {
    var q = shopQuery();
    var url = window.location.pathname + '?view=vtdata' + (q ? '&' + q : '') + (page > 1 ? '&page=' + page : '');
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (t) {
        var a = t.indexOf('{');
        var b = t.lastIndexOf('}');
        if (a < 0 || b < a) throw new Error('bad data');
        return JSON.parse(t.slice(a, b + 1));
      });
  }

  function loadData() {
    if (dataState === 'loading' || dataState === 'ready') return Promise.resolve(data);
    dataState = 'loading';
    drawGroups();
    var cached = null;
    try { cached = JSON.parse(storageGet('sessionStorage', dataKey()) || 'null'); } catch (e) { cached = null; }
    if (cached && cached.items && cached.v === DATA_V) {
      data = cached;
      dataState = 'ready';
      learnBases(data.items);
      drawGroups();
      return Promise.resolve(data);
    }
    return fetchJson(1).then(function (first) {
      data = { v: DATA_V, total: first.total, pages: first.pages, size: first.size, items: first.items.slice() };
      var rest = [];
      for (var p = 2; p <= Math.min(first.pages, 40); p += 1) rest.push(p);
      return rest.reduce(function (chain, p) {
        return chain.then(function () {
          return fetchJson(p).then(function (r) { data.items = data.items.concat(r.items); });
        });
      }, Promise.resolve());
    }).then(function () {
      dataState = 'ready';
      learnBases(data.items);
      try { storageSet('sessionStorage', dataKey(), JSON.stringify(data)); } catch (e) { /* full */ }
      drawGroups();
      return data;
    }).catch(function () {
      dataState = 'error';
      data = null;
      drawGroups();
    });
  }

  /* ---- what matches ---- */
  // which colour name the theme has a swatch colour for: the name itself, else its base colour word
  function swatchKey(label) {
    var low = String(label || '').toLowerCase();
    if (SWATCH_KEYS.indexOf(low) > -1) return low;
    var base = baseOf[label];
    if (base && SWATCH_KEYS.indexOf(base) > -1) return base;
    return '';
  }

  function learnBases(items) {
    (items || []).forEach(function (item) {
      (item.c || []).forEach(function (pair) { if (pair[0] && pair[1]) baseOf[pair[0]] = pair[1]; });
    });
  }

  function pairsMatch(pairs, colours, sizes) {
    if (!pairs || !pairs.length) return false;
    for (var i = 0; i < pairs.length; i += 1) {
      var c = pairs[i][0];
      var s = pairs[i][1];
      if (colours.length && colours.indexOf(c) < 0) continue;
      if (sizes.length && sizes.indexOf(s) < 0) continue;
      return true;
    }
    return false;
  }
  // in stock in the colour / size she asked for — the only thing the counts ever look at
  function itemMatches(item, colours, sizes) {
    return pairsMatch(item.v, colours, sizes);
  }
  // fixes 2: the colour / size she asked for exists on this piece, but it is sold out in it
  function itemMatchesSold(item, colours, sizes) {
    return pairsMatch(item.x, colours, sizes);
  }

  function facet(which) {
    // the colours (or sizes) of the whole collection, with how many products each one has, counted against
    // whatever is chosen in the OTHER group — so the numbers are always true.
    var other = which === 'color' ? sel.size : sel.color;
    var idx = which === 'color' ? 0 : 1;
    var oidx = idx === 0 ? 1 : 0;
    var map = {};
    (data ? data.items : []).forEach(function (item) {
      var seen = {};
      (item.v || []).forEach(function (pair) {
        var value = pair[idx];
        if (!value) return;
        if (other.length && other.indexOf(pair[oidx]) < 0) return;
        if (seen[value]) return;
        seen[value] = true;
        map[value] = (map[value] || 0) + 1;
      });
    });
    var list = Object.keys(map).map(function (k) { return { value: k, count: map[k] }; });
    if (which === 'size') {
      list.sort(function (a, b) {
        var na = parseFloat(a.value);
        var nb = parseFloat(b.value);
        if (isNaN(na) || isNaN(nb)) return a.value.localeCompare(b.value);
        return na - nb;
      });
    } else {
      list.sort(function (a, b) { return b.count - a.count || a.value.localeCompare(b.value); });
    }
    return list;
  }

  function recount() {
    matches = [];
    soldMatches = [];
    if (!data) return;
    if (!sel.color.length && !sel.size.length) return;
    data.items.forEach(function (item, i) {
      // a piece she can buy in this colour / size comes first and is counted; one that only exists in it
      // sold out goes to the end of the list, greyed out, and is never counted.
      if (itemMatches(item, sel.color, sel.size)) matches.push(i);
      else if (itemMatchesSold(item, sel.color, sel.size)) soldMatches.push(i);
    });
  }

  /* ---- drawing the two panels ---- */
  function groupEl(which) { return document.querySelector('[data-vt-tf="' + which + '"]'); }

  function drawGroup(which) {
    var g = groupEl(which);
    if (!g) return;
    g.hidden = false;
    var body = g.querySelector('[data-vt-tf-list]');
    var pillCount = g.querySelector('[data-vt-tf-count]');
    var chosen = sel[which];
    g.classList.toggle('has-chosen', chosen.length > 0);
    // round 15: the pill says what is chosen ("Colour: Black") and, when more than one is picked, "+2".
    // The Clear next to it only shows while something is chosen.
    var vals = g.querySelector('[data-vt-tf-vals]');
    if (vals) {
      vals.hidden = chosen.length === 0;
      vals.textContent = chosen.length ? chosen[0] : '';
      var lbl = g.querySelector('.vt-fbar__pill-label');
      if (lbl && !lbl.dataset.vtBase) lbl.dataset.vtBase = lbl.textContent;
      if (lbl) lbl.textContent = lbl.dataset.vtBase + (chosen.length ? ':' : '');
    }
    var pillClear = g.querySelector('[data-vt-pill-clear]');
    if (pillClear) pillClear.hidden = chosen.length === 0;
    if (pillCount) {
      var extra = vals ? chosen.length - 1 : chosen.length;
      pillCount.hidden = extra <= 0;
      var num = pillCount.querySelector('[data-vt-tf-num]');
      if (num) num.textContent = extra > 0 ? (vals ? '+' + extra : String(chosen.length)) : '';
    }
    if (!body) return;
    if (dataState === 'loading' || dataState === 'idle') {
      body.innerHTML = '<p class="vt-tf__state">' + esc(S.loadingOptions || '') + '</p>';
      return;
    }
    if (dataState === 'error') {
      body.innerHTML = '<p class="vt-tf__state">' + esc(S.optionsError || '') + '</p>';
      return;
    }
    var list = facet(which);
    if (!list.length) {
      body.innerHTML = '<p class="vt-tf__state">' + esc(S.noOptions || '') + '</p>';
      g.hidden = true;
      return;
    }
    var html = '';
    list.forEach(function (o) {
      var on = chosen.indexOf(o.value) > -1;
      // a real button with role="checkbox" — NOT a form field: Shopify's own filter form sits around this bar
      // and would send itself off (and lose the address) if these were ordinary checkboxes.
      html += '<button type="button" class="vt-tf__item vt-tf__item--' + which + (on ? ' is-on' : '') + '"' +
        ' role="checkbox" aria-checked="' + (on ? 'true' : 'false') + '"' +
        ' data-vt-tf-value="' + esc(o.value) + '" data-vt-tf-group="' + which + '">' +
        (which === 'color'
          ? '<span class="vt-tf__dot"' + (swatchKey(o.value) ? ' data-swatch="' + esc(swatchKey(o.value)) + '"' : '') + ' aria-hidden="true"></span>'
          : '') +
        '<span class="vt-tf__name">' + esc(o.value) + '</span>' +
        '<span class="vt-tf__count">' + o.count + '</span>' +
        '</button>';
    });
    html += '<button type="button" class="vt-tf__clear" data-vt-tf-clear="' + which + '"' + (chosen.length ? '' : ' hidden') + '>' + esc(S.clear || '') + '</button>';
    body.innerHTML = html;
  }

  function drawChips() {
    var box = document.querySelector('[data-vt-tf-chips]');
    if (!box) return;
    var html = '';
    ['color', 'size'].forEach(function (which) {
      sel[which].forEach(function (v) {
        var label = tpl(which === 'color' ? S.chipColour : S.chipSize, { value: v });
        html += '<button type="button" class="vt-tf__chip" data-vt-tf-drop="' + which + '" data-vt-tf-value="' + esc(v) + '">' +
          '<span>' + esc(label) + '</span>' +
          '<span class="vt-tf__chip-x" aria-hidden="true">&times;</span>' +
          '</button>';
      });
    });
    var any = sel.color.length + sel.size.length > 0;
    if (any) html += '<button type="button" class="vt-tf__chip vt-tf__chip--all" data-vt-tf-clear="all">' + esc(S.clearAll || '') + '</button>';
    box.innerHTML = html;
    box.hidden = !any;
  }

  function drawCount() {
    var line = document.querySelector('[data-vt-tf-count-line]');
    var any = sel.color.length + sel.size.length > 0;
    if (line) {
      line.hidden = !any || dataState !== 'ready';
      line.textContent = nOf(matches.length, S.showN, S.showOne);
    }
    var done = document.querySelector('[data-vt-filters-done]');
    if (done && any && dataState === 'ready') done.textContent = nOf(matches.length, S.showN, S.showOne);
  }

  function drawGroups() {
    drawGroup('color');
    drawGroup('size');
    drawChips();
    drawCount();
    var bar = document.querySelector('[data-vt-tf-bar]');
    if (bar) bar.hidden = false;
  }

  /* ---- the cards ---- */
  function harvestCards(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    cards(tmp).forEach(function (el) {
      var id = el.getAttribute('data-product-id');
      if (id && !cardCache[id]) cardCache[id] = el;
    });
  }

  function sectionUrl(page) {
    var q = shopQuery();
    var sec = fc() && fc().dataset.filterSectionId;
    return window.location.pathname + '?' + (q ? q + '&' : '') + (page > 1 ? 'page=' + page + '&' : '') +
      'section_id=' + encodeURIComponent(sec || '');
  }

  function fetchPage(page) {
    if (pagesFetched[page]) return pagesFetched[page];
    pagesFetched[page] = fetch(sectionUrl(page), { credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(harvestCards);
    pagesFetched[page].catch(function () { delete pagesFetched[page]; });
    return pagesFetched[page];
  }

  function pageOf(index) {
    var size = cfg.pageSize || 24;
    return Math.floor(index / size) + 1;
  }

  function cardFor(index) {
    var item = data.items[index];
    var el = cardCache[String(item.i)];
    if (!el) return null;
    var copy = el.cloneNode(true);
    copy.querySelectorAll('[data-cc-animate]').forEach(function (a) { a.removeAttribute('data-cc-animate'); });
    // 30 Sep 2026: the copy carries the "dots already wired" mark (data-vt-bound) but not the wiring itself, so
    // its colour dots did nothing (and the chosen colour's photo never showed). Clear it so the card wires them.
    copy.querySelectorAll('[data-vt-bound]').forEach(function (d) { d.removeAttribute('data-vt-bound'); });
    return copy;
  }

  // show the photo of a colour she asked for, when the card knows it.
  // 30 Sep 2026: matched on the dot's own colour name (data-option-item, e.g. "Brown" or "Brown / 38"), in any
  // letter case — data-swatch is not always there, which is why cards kept their first photo.
  function showChosenColour(card) {
    if (!sel.color.length) return;
    var items = card.querySelectorAll('.product-block-options__item');
    for (var i = 0; i < sel.color.length; i += 1) {
      var want = sel.color[i].toLowerCase().trim();
      for (var j = 0; j < items.length; j += 1) {
        var name = (items[j].getAttribute('data-option-item') || items[j].getAttribute('data-swatch') || '').toLowerCase().trim();
        if (name === want || name.indexOf(want + ' /') === 0) {
          if (!items[j].classList.contains('is-active') && !items[j].classList.contains('product-block-options__item--active')) items[j].click();
          return;
        }
      }
    }
  }

  // 30 Sep 2026: put the chosen colour's own photo (from the data file, "p") on the card's first picture
  function showColourPhoto(card, item) {
    if (!sel.color.length || !item || !item.p || !item.p.length) return;
    var url = '';
    for (var i = 0; i < sel.color.length && !url; i += 1) {
      var want = sel.color[i].toLowerCase().trim();
      for (var j = 0; j < item.p.length; j += 1) {
        if (String(item.p[j][0]).toLowerCase().trim() === want) { url = item.p[j][1]; break; }
      }
    }
    if (!url) return;
    var img = card.querySelector('.product-block__image img, img');
    if (!img || (img.currentSrc || img.src || '').split('?')[0] === url.split('?')[0]) return;
    var base = url.replace(/([?&])width=\d+/, '$1width=');
    img.removeAttribute('loading');
    img.srcset = base + '360 360w, ' + base + '600 600w, ' + base + '900 900w';
    img.src = base + '600';
  }

  // 30 Sep 2026: the phone "Filter & sort" button says what is chosen and how many match (it kept saying
  // "All 44 products"); back to the shop's own words when the theme filters are cleared
  function drawTrigger() {
    document.querySelectorAll('[data-vt-trigger-sub]').forEach(function (sub) {
      if (sub.dataset.vtOrig == null) sub.dataset.vtOrig = sub.textContent;
      if (!tfOn) { sub.textContent = sub.dataset.vtOrig; return; }
      var bits = sel.color.concat(sel.size);
      // only sold-out pieces match: say so, instead of "0 products match" above a greyed card
      var tail = matches.length === 0 && soldMatches.length ? (S.soldTitle || '') : nOf(matches.length, S.found, S.foundOne);
      sub.textContent = bits.join(' · ') + ' · ' + tail;
    });
  }

  /* fixes 2: the quiet line that separates the pieces she can buy from the ones that are sold out in the
     colour / size she asked for. It sits in the grid itself, across the whole row, so nothing jumps. */
  function soldDivider() {
    var div = document.createElement('div');
    div.className = 'vt-tf__soldline';
    div.setAttribute('data-vt-tf-soldline', '');
    div.innerHTML = '<span class="vt-tf__soldline-title">' + esc(S.soldTitle || '') + '</span>' +
      (S.soldNote ? '<span class="vt-tf__soldline-note">' + esc(S.soldNote) + '</span>' : '');
    return div;
  }

  // the shop's own sold-out card treatment (soft, desaturated photo + the "Sold out" label) — the server
  // already renders it that way; this only makes sure of it for a card that somehow came without it.
  function markSold(card) {
    if (!card.hasAttribute('data-vt-sold')) card.setAttribute('data-vt-sold', '');
    if (!card.classList.contains('product-block--vt10-sold')) card.classList.add('product-block--vt10-sold');
    card.setAttribute('data-vt-tf-sold', '');
  }

  function renderMore() {
    if (drawing) return drawing;
    var myGen = gen;
    var g = grid();
    if (!g || !data) return Promise.resolve();
    var size = cfg.pageSize || 24;
    // everything she can buy first; only once all of that is on the page do the sold-out ones follow
    var soldPhase = shown >= matches.length;
    var want = soldPhase ? soldMatches.slice(soldShown, soldShown + size) : matches.slice(shown, shown + size);
    if (!want.length) { drawTail(); return Promise.resolve(); }
    var firstSold = soldPhase && soldShown === 0;
    var pages = {};
    want.forEach(function (i) { pages[pageOf(i)] = true; });
    setBusy(true);
    drawing = Promise.all(Object.keys(pages).map(function (p) { return fetchPage(parseInt(p, 10)); }))
      .then(function () {
        if (myGen !== gen) return;   // she changed the filter meanwhile: this list is out of date
        if (firstSold) g.appendChild(soldDivider());
        want.forEach(function (i) {
          var card = cardFor(i);
          if (!card) return;
          var pid = card.getAttribute('data-product-id');
          if (pid && g.querySelector('[data-product-id="' + pid + '"]')) return;   // never the same piece twice
          if (soldPhase) markSold(card);
          g.appendChild(card);
          showChosenColour(card);
          showColourPhoto(card, data.items[i]);
        });
        if (soldPhase) soldShown += want.length; else shown += want.length;
        if (window.vtDrawCardLists) window.vtDrawCardLists();
        document.dispatchEvent(new CustomEvent('vt:products:appended', { detail: { count: want.length, theme: true, sold: soldPhase } }));
        drawTail();
      })
      .catch(function () { drawTail(true); })
      .then(function () { drawing = null; setBusy(false); if (myGen === gen) maybeMore(); });
    return drawing;
  }

  // Fixes 2: when the end of the list is already on the screen (a short list, or only one or two pieces in
  // stock in this colour), carry on by itself — so the sold-out ones at the end are not left behind a button
  // she can already see. A watcher only speaks up when something CHANGES, and an end that never left the
  // screen never changes, so it is asked here directly. The 10-page limit still applies.
  function maybeMore() {
    if (!tfOn) return;
    if (shown >= matches.length && soldShown >= soldMatches.length) return;
    if (shown + soldShown >= (cfg.pageSize || 24) * MAX_AUTO_PAGES) return;
    var tail = document.querySelector('[data-vt-tf-tail]');
    if (!tail) return;
    var box = tail.getBoundingClientRect();
    if (box.top < (window.innerHeight || 0) + 600) window.setTimeout(renderMore, 60);
  }

  function setBusy(on) {
    var host = document.querySelector('[data-vt-tf-results]');
    if (host) host.classList.toggle('is-loading', !!on);
    var g = grid();
    if (g) g.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  function drawTail(failed) {
    var tail = document.querySelector('[data-vt-tf-tail]');
    if (!tail) return;
    if (!tfOn) { tail.hidden = true; tail.innerHTML = ''; return; }
    tail.hidden = false;
    if (failed) {
      tail.innerHTML = '<p class="vt-tf__state">' + esc(S.optionsError || '') + '</p>';
      return;
    }
    if (shown < matches.length) {
      tail.innerHTML = '<button type="button" class="btn btn--secondary vt-tf__more" data-vt-tf-more>' +
        esc(tpl(S.showMoreN, { count: matches.length - shown })) + '</button>';
      return;
    }
    // fixes 2: the sold-out ones come after — their own quiet button, so the count above stays about
    // what she can actually buy
    if (soldShown < soldMatches.length) {
      tail.innerHTML = '<button type="button" class="btn btn--secondary vt-tf__more vt-tf__more--sold" data-vt-tf-more>' +
        esc(tpl(S.soldMoreN, { count: soldMatches.length - soldShown })) + '</button>';
      return;
    }
    tail.innerHTML = matches.length || soldMatches.length ? '<p class="vt-tf__state vt-tf__state--end">' + esc(S.allShown || '') + '</p>' : '';
  }

  function drawEmpty() {
    var box = document.querySelector('[data-vt-tf-empty]');
    if (!box) return;
    // fixes 2: "nothing at all" now means nothing in stock AND nothing sold out either — when only sold-out
    // pieces match, the list shows those (greyed, under their own line) instead of the empty state
    var empty = tfOn && dataState === 'ready' && matches.length === 0 && soldMatches.length === 0;
    box.hidden = !empty;
    if (!empty) return;
    box.innerHTML = '<p class="vt-tf__empty-title">' + esc(S.emptyTitle || '') + '</p>' +
      '<p class="vt-tf__empty-text">' + esc(S.emptyText || '') + '</p>' +
      '<button type="button" class="btn btn--secondary" data-vt-tf-clear="all">' + esc(S.clearAll || '') + '</button>';
  }

  /* ---- switching the theme filters on and off ---- */
  function stash() {
    var g = grid();
    if (!g || serverKids) return;
    soldFlush();
    serverKids = document.createDocumentFragment();
    while (g.firstChild) serverKids.appendChild(g.firstChild);
    var r = row();
    if (r) r.hidden = true;
    document.body.classList.add('vt-tf-on');
  }

  function unstash() {
    var g = grid();
    if (!g || !serverKids) return;
    while (g.firstChild) g.removeChild(g.firstChild);
    g.appendChild(serverKids);
    serverKids = null;
    var r = row();
    if (r) r.hidden = false;
    document.body.classList.remove('vt-tf-on');
    if (window.vtDrawCardLists) window.vtDrawCardLists();
  }

  function apply(push) {
    gen += 1;
    drawing = null;
    tfOn = sel.color.length + sel.size.length > 0;
    writeUrl(push);
    if (!tfOn) {
      drawTrigger();
      unstash();
      matches = [];
      soldMatches = [];
      shown = 0;
      soldShown = 0;
      drawGroups();
      drawTail();
      drawEmpty();
      return;
    }
    if (dataState !== 'ready') {
      // the colours and sizes are still on their way: draw the list as soon as they arrive
      drawGroups();
      loadData().then(function () { if (dataState === 'ready') apply(false); });
      return;
    }
    recount();
    stash();
    var g = grid();
    if (g) while (g.firstChild) g.removeChild(g.firstChild);
    shown = 0;
    soldShown = 0;
    drawGroups();
    drawEmpty();
    drawTail();
    announce(nOf(matches.length, S.found, S.foundOne));
    drawTrigger();
    // renderMore() draws the in-stock ones first and moves on to the sold-out ones by itself
    if (matches.length || soldMatches.length) renderMore();
  }

  function toggle(which, value) {
    var at = sel[which].indexOf(value);
    if (at > -1) sel[which].splice(at, 1); else sel[which].push(value);
    apply(true);
  }

  function initThemeFilters() {
    var mode = TF.mode || 'auto';
    if (mode === 'off') return;
    if (mode === 'auto' && (TF.hasColour || TF.hasSize)) return; // Shopify gives real option filters: use those
    if (!fc() || !grid()) return;
    if (!document.querySelector('[data-vt-tf]')) return;

    readUrl();
    drawGroups();

    document.addEventListener('click', function (e) {
      var box = e.target.closest && e.target.closest('[data-vt-tf-value][data-vt-tf-group]');
      if (box) {
        e.preventDefault();
        toggle(box.getAttribute('data-vt-tf-group'), box.getAttribute('data-vt-tf-value'));
        return;
      }
      var drop = e.target.closest && e.target.closest('[data-vt-tf-drop]');
      if (drop) { e.preventDefault(); toggle(drop.getAttribute('data-vt-tf-drop'), drop.getAttribute('data-vt-tf-value')); return; }
      var clear = e.target.closest && e.target.closest('[data-vt-tf-clear]');
      if (clear) {
        e.preventDefault();
        var which = clear.getAttribute('data-vt-tf-clear');
        if (which === 'all') { sel.color = []; sel.size = []; } else { sel[which] = []; }
        apply(true);
        return;
      }
      var more = e.target.closest && e.target.closest('[data-vt-tf-more]');
      if (more) { e.preventDefault(); renderMore(); }
    });

    window.addEventListener('popstate', function () {
      readUrl();
      apply(false);
    });

    // Symmetry re-draws the whole filter bar after a Shopify filter / sort change
    document.addEventListener('vt:filterbar:render', drawGroups);
    onListingRefresh(function () {
      // a Shopify filter (Availability / Price) or a new sort order re-drew the whole list: everything we kept
      // belongs to the old list. The colours and sizes are read again for the new one, and her colour / size
      // choice is put back on top of it.
      serverKids = null;
      cardCache = {};
      pagesFetched = {};
      data = null;
      dataState = 'idle';
      document.body.classList.remove('vt-tf-on');
      loadData().then(function () {
        if (dataState === 'ready' && (sel.color.length || sel.size.length)) apply(false);
      });
    });

    if (sel.color.length || sel.size.length) {
      // she opened a shared address that already carries a choice: fetch at once and draw the chosen list
      document.body.classList.add('vt-tf-waiting');
      loadData().then(function () {
        document.body.classList.remove('vt-tf-waiting');
        apply(false);
      });
    } else {
      // otherwise the list of colours and sizes is fetched quietly, only after the first paint
      var start = function () { loadData(); };
      if ('requestIdleCallback' in window) window.requestIdleCallback(start, { timeout: 4000 });
      else window.setTimeout(start, 1200);
    }

    // infinite scroll inside the theme's own results
    if ('IntersectionObserver' in window) {
      var tail = document.querySelector('[data-vt-tf-tail]');
      if (tail) {
        new IntersectionObserver(function (entries) {
          if (!entries.some(function (x) { return x.isIntersecting; })) return;
          if (!tfOn) return;
          // fixes 2: keep going past the in-stock ones into the sold-out ones at the end
          if (shown >= matches.length && soldShown >= soldMatches.length) return;
          if (shown + soldShown >= (cfg.pageSize || 24) * MAX_AUTO_PAGES) return;
          renderMore();
        }, { rootMargin: SENTINEL_MARGIN }).observe(tail);
      }
    }
  }

  /* ------------------------------------------------------------------ boot */
  function boot() {
    if (!fc()) return;
    initSoldLast();
    initInfinite();
    initThemeFilters();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
